import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ModuleTile } from '@platform/ui';
import { routes } from '@platform/core/lib/routes';
import { moduleNav } from '@platform/navigation';
import type { IAreaModuleCardsProps } from './IAreaModuleCardsProps';

/**
 * Картки модулів огляду напряму (прототип v4 G:L1860): сітка minmax(260px, 1fr), картка радіус 12 — плитка 32px, назва 15px, «N прострочено»
 * кольором небезпеки, опис 13px у два рядки, смуга відкритих 6px (акцент) і «N відкрито · M» IBM Plex Mono; наведення — акцентна рамка.
 */
export function AreaModuleCards({ cards }: IAreaModuleCardsProps) {
  const { t } = useTranslation();
  return (
    <section className="ar-section" aria-label={t('areaPage.modules')}>
      <span className="ar-label">{t('areaPage.modules')}</span>
      <div className="ar-cards">
        {cards.map((c) => {
          const nav = moduleNav(c.key);
          return (
            <Link key={c.key} className="ar-card" to={routes.module(c.key)}>
              <span className="ar-card__top">
                <ModuleTile icon={nav.icon} tone={nav.tone} size={32} />
                <strong className="ar-card__name">{c.name}</strong>
                {c.overdue > 0 && <span className="ar-card__over">{t('areaPage.overdueCount', { count: c.overdue })}</span>}
              </span>
              <span className="ar-card__desc">{c.description}</span>
              <span className="ar-card__bar">
                <span className="ar-card__track"><span className="ar-card__fill" style={{ width: `${c.width}%` }} /></span>
                <span className="ar-card__count">{t('areaPage.openOf', { open: c.open, total: c.total })}</span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
